import { call, put, takeLatest } from "redux-saga/effects";
import {
  SG_GET_SURVEY_EVENT_RESPONSES,
  GET_SURVEY_EVENT_RESPONSES,
  SG_FETCH_SURVEY_EVENT_RESPONSE,
  FETCH_SURVEY_EVENT_RESPONSE,
  SG_ADD_SURVEY_EVENT_RESPONSE,
  ADD_SURVEY_EVENT_RESPONSE,
  SG_UPDATE_SURVEY_EVENT_RESPONSE,
  UPDATE_SURVEY_EVENT_RESPONSE,
  SG_DELETE_SURVEY_EVENT_RESPONSE,
  DELETE_SURVEY_EVENT_RESPONSE,
  SURVEY_EVENT_RESPONSES_PENDING,
  ALL_ERRORS,
} from "constants/actions";
import * as api from "constants/api";

function* getSurveyEventResponses(action) {
  try {
    yield put({ type: SURVEY_EVENT_RESPONSES_PENDING });
    const response = yield call(api.GET_SURVEY_EVENT_RESPONSES, action.payload);
    yield put({ type: GET_SURVEY_EVENT_RESPONSES, payload: response.data });
  } catch (e) {
    yield put({ type: ALL_ERRORS, payload: e.response });
  }
}

function* fetchSurveyEventResponse(action) {
  try {
    yield put({ type: SURVEY_EVENT_RESPONSES_PENDING });
    const response = yield call(api.FETCH_SURVEY_EVENT_RESPONSE, action.payload);
    yield put({ type: FETCH_SURVEY_EVENT_RESPONSE, payload: response.data });
  } catch (e) {
    yield put({ type: ALL_ERRORS, payload: e.response });
  }
}

function* addSurveyEventResponse(action) {
  try {
    yield put({ type: SURVEY_EVENT_RESPONSES_PENDING });
    const response = yield call(api.ADD_SURVEY_EVENT_RESPONSE, action.payload);
    yield put({ type: ADD_SURVEY_EVENT_RESPONSE, payload: response.data });
  } catch (e) {
    yield put({ type: ALL_ERRORS, payload: e.response });
  }
}

function* updateSurveyEventResponse(action) {
  try {
    yield put({ type: SURVEY_EVENT_RESPONSES_PENDING });
    const response = yield call(api.UPDATE_SURVEY_EVENT_RESPONSE, action.payload);
    yield put({ type: UPDATE_SURVEY_EVENT_RESPONSE, payload: response.data });
  } catch (e) {
    yield put({ type: ALL_ERRORS, payload: e.response });
  }
}

function* deleteSurveyEventResponse(action) {
  try {
    yield put({ type: SURVEY_EVENT_RESPONSES_PENDING });
    yield call(api.DELETE_SURVEY_EVENT_RESPONSE, action.payload);
    yield put({ type: DELETE_SURVEY_EVENT_RESPONSE, payload: action.payload });
  } catch (e) {
    yield put({ type: ALL_ERRORS, payload: e.response });
  }
}

export default function* surveyEventResponsesSaga() {
  yield takeLatest(SG_GET_SURVEY_EVENT_RESPONSES, getSurveyEventResponses);
  yield takeLatest(SG_FETCH_SURVEY_EVENT_RESPONSE, fetchSurveyEventResponse);
  yield takeLatest(SG_ADD_SURVEY_EVENT_RESPONSE, addSurveyEventResponse);
  yield takeLatest(SG_UPDATE_SURVEY_EVENT_RESPONSE, updateSurveyEventResponse);
  yield takeLatest(SG_DELETE_SURVEY_EVENT_RESPONSE, deleteSurveyEventResponse);
}